import { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const albums = {
  location: [
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/a16m95v3_FB_IMG_1770407268708.jpg', alt: 'BARBAAR bar', span: 'col-span-2 row-span-2' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/btdsd6oa_FB_IMG_1770407271743.jpg', alt: 'BARBAAR interieur', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/sej0xcfn_FB_IMG_1770407274720.jpg', alt: 'Terras', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/ayc7a32z_FB_IMG_1770407289767.jpg', alt: 'Spiegel', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/zz0pt2gk_FB_IMG_1770407411423.jpg', alt: 'Decoratie', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/wdt3crgh_FB_IMG_1770407405617.jpg', alt: 'Houten bar', span: 'col-span-2 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/mdqyvlh4_FB_IMG_1770407346249.jpg', alt: 'Edison lamp', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/mpggldq6_FB_IMG_1770407284759.jpg', alt: 'Detail', span: 'col-span-1 row-span-1' },
  ],
  food: [
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/1ejvwmrv_pixelcut-export-1775263013893.jpg', alt: 'Tataki van tonijn', span: 'col-span-2 row-span-2' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/w0zotuqy_pixelcut-export-1775263307886.jpg', alt: 'Oestertjes BabyKiss', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/lhdpmzyu_pixelcut-export-1775263147769.jpg', alt: 'Crispy Bites', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/tewv6kw8_pixelcut-export-1775263097210.jpg', alt: 'Asparagus Delight', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/d3sqtlvd_pixelcut-export-1775263234054.jpg', alt: 'BBQ Pork Belly', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/z0uaqj7m_pixelcut-export-1775263582091.jpg', alt: 'Butchers Board', span: 'col-span-2 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/6ggxo4b1_pixelcut-export-1775263416290.jpg', alt: 'Loaded Crispy Potatoes', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/wad69ocv_pixelcut-export-1775263683639.jpg', alt: 'Crispy Vegetable Bites', span: 'col-span-1 row-span-1' },
  ],
  drinks: [
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/56wlshqc_20260414_115456%281%29_resized.jpg', alt: 'Sangria', span: 'col-span-2 row-span-2' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/542rn9ub_FB_IMG_1770407386693.jpg', alt: 'Cocktails', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/feqv4sg4_20260417_212245_resized.jpg', alt: 'Wijn op terras', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/v0g1n2qu_FB_IMG_1770407334664.jpg', alt: 'Mojito', span: 'col-span-2 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/oqcp1qnx_20260524_122958.jpg', alt: 'Cocktail selectie', span: 'col-span-2 row-span-2' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/uo8cpi2r_20260426_111411.jpg', alt: 'Aperol Spritz', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/08bwdfxm_20260411_125413.jpg', alt: 'Signature cocktail', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/bxi4om6a_20260406_205515.jpg', alt: 'Bubbels op terras', span: 'col-span-1 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/hqs4dgns_3%281%29.png', alt: 'Signature cocktails duo', span: 'col-span-2 row-span-1' },
    { src: 'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/zmqq6hwa_ADV.FOTO-INRICHTING-4-scaled.jpg', alt: 'BARBAAR lounge', span: 'col-span-1 row-span-1' },
  ],
};

const TABS = [
  { key: 'location', label: { nl: 'Location', en: 'Location' } },
  { key: 'food', label: { nl: 'Food', en: 'Food' } },
  { key: 'drinks', label: { nl: 'Drinks', en: 'Drinks' } },
];

const Fotos = () => {
  const { t, language } = useLanguage();
  const [activeTab, setActiveTab] = useState('location');

  const images = albums[activeTab];

  return (
    <main className="min-h-screen bg-[#0A0A0A] pt-24" data-testid="fotos-page">
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-body text-sm tracking-[0.2em] text-copper mb-4 uppercase"
          >
            {t.photos.subtitle}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="font-heading text-5xl md:text-7xl font-bold text-[#EDEDED] mb-6"
          >
            {t.photos.title}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="font-body text-[#A1A1A1] text-lg max-w-2xl mx-auto mb-10"
          >
            {t.photos.description}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="flex justify-center gap-2 md:gap-4"
          >
            {TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`font-heading text-xs md:text-sm tracking-wider uppercase px-5 md:px-8 py-2.5 md:py-3 border transition-all duration-300 ${
                  activeTab === tab.key
                    ? 'bg-[#C8A46A] text-[#0A0A0A] border-[#C8A46A]'
                    : 'bg-[#141414] text-[#A1A1A1] border-[#2A2A2A] hover:border-[#C8A46A]/50'
                }`}
                data-testid={`photo-tab-${tab.key}`}
              >
                {tab.label[language]}
              </button>
            ))}
          </motion.div>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px] md:auto-rows-[250px]"
          >
            {images.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className={`${image.span} overflow-hidden group cursor-pointer relative`}
                data-testid={`gallery-image-${activeTab}-${index}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 filter grayscale-[30%] group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <p className="font-body text-sm text-white">{image.alt}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default Fotos;
